module.exports = require('./toPairs');